import { defineMessages } from 'react-intl';

import { pullRequestStatusMessages } from '../../../../../../../common/utils/pull-request-status';

const localMessages = defineMessages({
	resultLabel: {
		id: 'search-pull-request-result.label',
		defaultMessage: 'Pull request',
		description: 'Badge label shown on a pull request search result to indicate the result type.',
	},
	commentsLabel: {
		id: 'search-pull-request-result.comments-label',
		defaultMessage: '{count} {count, plural, one {comment} other {comments}}',
		description: 'Label for the PR comments expand section, showing the number of comments',
	},
});

export const messages: {
	status_open: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	status_merged: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	status_declined: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	status_draft: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	status_unknown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resultLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = {
	...localMessages,
	...pullRequestStatusMessages,
};
